module.exports = __webpack_public_path__ + "img/giftitle.a116bb90.gif";